import React from "react";
import { Container, Row, Col, Button, Form, Nav, Navbar } from "react-bootstrap";
import "./App.css";
import heroImage from "./assets/hero-group.jpg"; // Replace with actual image
import phoneImage from "./assets/phone.jpg"; // Replace with actual image
import friendsImage from "./assets/friends.jpg"; // Replace with actual image
import businessImage from "./assets/business.jpg"; // Replace with actual image;
import ctaImage from "./assets/cta-portrait.jpg"; // Replace with actual image

const Landing = () => {
  return (
    <div className="landing-page">
      {/* Navbar */}
      <Navbar expand="lg" className="custom-navbar">
        <Container>
          <Navbar.Brand href="#" className="logo">DinDin 💸</Navbar.Brand>
          <Navbar.Toggle aria-controls="navbar-nav" />
          <Navbar.Collapse id="navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="#send">Enviar & Recibir</Nav.Link>
              <Nav.Link href="#pay">Paga con DinDin</Nav.Link>
              <Nav.Link href="#business">Para Negocios</Nav.Link>
              <Nav.Link href="#help">Ayuda</Nav.Link>
              <Nav.Link href="#login" className="login-btn">Iniciar Sesión</Nav.Link>
              <Button variant="outline-dark" className="get-dindin-btn">Descargar DinDin</Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Hero Section */}
      <Container fluid className="hero-section">
        <Container className="hero-container">
          <Row className="align-items-center">
            {/* Text Section (Aligned with Logo) */}
            <Col md={6} className="text-section">
              <h1 className="fw-bold display-3">Instantáneo, Seguro y Sin Comisiones</h1>
              <p className="lead">
                Paga, recibe dinero, haz crecer tu negocio y mucho más. Todo con DinDin.
              </p>

              {/* Signup Box */}
              <div className="signup-box">
                <h3>🚀 Únete a la lista de espera</h3>
                <p>Sé de los primeros en probar DinDin y descubre pagos instantáneos, seguros y sin comisiones.</p>
                <Form className="d-flex">
                  <Form.Control type="email" placeholder="Tu correo electrónico" className="me-2" />
                  <Button variant="dark">Regístrate</Button>
                </Form>
              </div>
            </Col>

            {/* Image Section (Larger & More to the Right) */}
            <Col md={6} className="image-section">
              <div className="hero-image-wrapper">
                <img src={heroImage} alt="Friends using DinDin" className="hero-image" />
                <div className="payment-bubble">
                  <p>Le pagaste a Trish A</p>
                  <p>Picnic en el parque 🥪</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>

      {/* "Paga a Amigos" Section */}
      <Container className="pay-friends-section">
        <Row className="align-items-center">
          {/* Text Section */}
          <Col md={6} className="text-section">
            <h2 className="fw-bold display-4">Paga a amigos</h2>
            <p className="lead">
              DinDin hace que pagar entre amigos sea tan fácil como ponerse al día. 
              Envía y recibe dinero con tus contactos para dividir gastos del día a día, 
              cuentas y experiencias compartidas como comida para llevar o viajes.
            </p>
            <Button variant="outline-dark" className="learn-more-btn">Aprender más</Button>
          </Col>

          {/* Image Section with Floating Images */}
          <Col md={6} className="image-section">
            <div className="floating-images">
              <img src={phoneImage} alt="Phone showing DinDin app" className="floating-image phone-image" />
              <img src={friendsImage} alt="Friends having fun" className="floating-image friends-image" />
            </div>
          </Col>
        </Row>
      </Container>

     {/* "Haz Crecer Tu Negocio" Section */}
<Container className="business-section">
  <Row className="align-items-center">
    {/* Image Section (Left) */}
    <Col md={6} className="image-section">
      <img src={businessImage} alt="Small business using DinDin" className="business-image" />
    </Col>

    {/* Text Section (Right) */}
    <Col md={6} className="text-section">
      <h2 className="fw-bold display-4">Haz crecer tu negocio</h2>
      <p className="lead">
        Acepta pagos de clientes y conéctate con ellos gracias a una experiencia de pago sencilla, rápida y confiable.
      </p>
      <Button variant="outline-dark" className="learn-more-btn business-btn">Aprender más</Button>
    </Col>
  </Row>
</Container>

      {/* Call to Action Section */}
      <Container fluid className="cta-section">
  <Container>
    <Row className="align-items-center">
      {/* Text Section (Left) */}
      <Col md={6} className="text-section">
        <h2 className="fw-bold display-4">Únete a DinDin ahora</h2>
        <p className="lead">
          Transfiere dinero al instante, sin comisiones y con la mejor experiencia social. Sé parte de DinDin.
        </p>
        <Button variant="dark" size="lg" className="cta-btn">Descargar DinDin</Button>
      </Col>

      {/* Image Section (Right) - Placeholder */}
      <Col md={6} className="image-section">
        <div className="portrait-placeholder">
          {/* Replace src with the actual image later */}
          <img src={ctaImage} alt="CTA Portrait" className="cta-image" />
        </div>
      </Col>
    </Row>
  </Container>
</Container>

{/* Footer Section */}
<footer className="footer-section">
  <Container>
    <Row className="justify-content-center text-center">
      <Col md={12}>
        <p>© 2025 DinDin - Hecho con 💜 desde LATAM</p>
      </Col>
    </Row>
  </Container>
</footer>


      
    </div>
  );
};

export default Landing;
